import { getFilteredPricesByCountryCodeAndCurrency } from "./formatProduct"

import { Product } from "@secureo/common/typings/generated/commercetools-graphql"
import { LockingSystemPreviewProduct } from "@secureo/common/typings/LockingSystem"
import formatAttributes from "./formatAttributes"
import { CurrencyCode } from "@secureo/common/typings/Forex"

const formatLockingSystemPreviewProduct = (
	lockingSystemPreviewProduct: Product,
	currencyCode: CurrencyCode,
) => {
	const {
		id,
		masterData: {
			current: {
				name,
				masterVariant: { sku, prices, attributesRaw = [], images = [] },
			},
		},
	} = lockingSystemPreviewProduct

	const pricesByCountryCode = getFilteredPricesByCountryCodeAndCurrency(prices, currencyCode)

	const {
		lockingSystemComponentType,
		lockingSystemComponentName,
		lockingSystemChargesByMatrixType,
	} = formatAttributes(attributesRaw)

	const formattedImages = images.map((image) => image.url)

	const formattedLockingSystemPreviewProduct: LockingSystemPreviewProduct = {
		id,
		name: lockingSystemComponentName || name,
		productName: name,
		sku,
		pricesByCountryCode,
		lockingSystemComponentType,
		lockingSystemChargesByMatrixType,
		images: formattedImages,
	}

	return formattedLockingSystemPreviewProduct
}

export default formatLockingSystemPreviewProduct
